import React from "react";
import { ArcBox, ArcSkeleton, ArcStack } from "@src/core/ui";

interface OrdersSkeletonProps {
  count: number;
}

const OrdersSkeleton: React.FC<OrdersSkeletonProps> = ({ count }) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <ArcBox
        key={index}
        p={1.5}
        bgcolor="grey.900"
        borderRadius={1}
        sx={{ border: "1px solid", borderColor: "grey.900" }}>
        <ArcStack direction="column" spacing={1}>
          <ArcStack direction="row" justifyContent="space-between" alignItems="center">
            <ArcSkeleton variant="text" width={72} height={18} />
            <ArcSkeleton variant="text" width={104} height={18} />
          </ArcStack>
          <ArcStack direction="row" alignItems="center" spacing={1}>
            <ArcSkeleton variant="text" height={18} sx={{ flex: 1 }} />
            <ArcSkeleton variant="rounded" width={64} height={22} />
          </ArcStack>
        </ArcStack>
      </ArcBox>
    ))}
  </>
);

export default OrdersSkeleton;
